export default __webpack_public_path__ + "static/container-piece-1-e05e61158ab91207ab222fceeebe281b.jpg";